import { css } from '@bts-web/utils-style-engine';

const headerStyles = css({
  fontSize: 'caption.medium_medium',
  lineHeight: 'label.medium_medium',
  letterSpacing: 'label.medium_medium',
  fontWeight: 'label.medium_medium',
  color: 'neutrals.text_secondary',
});

export const TwoColumnHeaders = ({
  firstColumnHeader,
  secondColumnHeader,
  withBorderBottom = false,
}: {
  firstColumnHeader: string;
  secondColumnHeader: string;
  withBorderBottom?: boolean;
}) => {
  return (
    <div
      data-testid="two-column-headers"
      className={css({
        display: 'flex',
        gap: 'extra_small_2',
        justifyContent: 'space-between',
        py: 'extra_small',
        mx: 'calc(var(--spacing-medium) * -1)',
        px: 'medium',
        ...(withBorderBottom
          ? {
              borderBottom: '1px solid',
              borderBottomColor: 'neutrals.divider',
            }
          : {}),
      })}
    >
      <div className={headerStyles}>{firstColumnHeader}</div>

      <div className={headerStyles}>{secondColumnHeader}</div>
    </div>
  );
};
